import { render, staticRenderFns } from "./AssignNode.vue?vue&type=template&id=4a96d174&"
import script from "./AssignNode.vue?vue&type=script&lang=js&"
export * from "./AssignNode.vue?vue&type=script&lang=js&"
import style0 from "./AssignNode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports